import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "divider",
    "explanation",
    "chevron"
  ]

  togglePanel() {
    this.dividerTarget.classList.toggle("hidden")
    this.explanationTarget.classList.toggle("hidden")
    this.chevronTarget.classList.toggle("fa-chevron-down")
    this.chevronTarget.classList.toggle("fa-chevron-right")
  }
}
